export default {
    lang: "哈萨克语",
    application: {
        name: "Інформация жариялау жүйесі",
    },
    ajaxTip: {
        success: "Сәтті",
        error: "Басарасыз",
        noAccess: "Бұл ресурсқа кіру рұқсаты жоқ",
        notFound: "Кіріскен ресурс жоқ",
        serverBusy: "Сервер жұмыс жасаған",
        timeOut: "Уақыт аяқталды",
    },
    menu: {
        home: "Басты бет",
        template: "Шаблондарды басқару",
        program: "Бағдарламаларды басқару",
        playplan: "Ойнату жоспары",
        device: "Құрылғыларды басқару",
        "source-material": "Материалдарды басқару",
        material: "Материал",
        checkManage: "Тексеруді басқару",
        setting: "Баптаулар",
        usercenter: "Пайдаланушы орталығы",
        adminManage: "Құрылғыларды басқару",
        schedule: "Орындатылмаған жұмыстар",
        capitalassets: "Активтерді басқару",
        modifyPassword: "Құпия сөзді өзгерту",
        logout: "Шығу",
        "add": "Қосу",
        "edit": "Өзгерту",
        "delete": "Өшіру",
        "view": "Қарау",
        "menu_1": "Басты бет",
        "menu_2": "Құрылғыларды басқару",
        "menu_3": "Өзгерту (Жоғары дәрежелі баптамалар - Әдеттегі өзгерту - Желіні ауыстыру)",
        "menu_4": "Тез командалар",
        "menu_5": "Өзгерту (Бөлімді көшіру)",
        "menu_6": "Стратегия",
        "menu_7": "Дыбыс деңгейін баптау",
        "menu_8": "Жарықтықты баптау",
        "menu_9": "Жүктеу баптамалары",
        "menu_10": "Тықталу баптамалары",
        "menu_11": "Құрылғының қасиеттері",
        "menu_12": "Өзгерту/Қосу",
        "menu_13": "Программаларды басқару",
        "menu_14": "Жариялау тарихы",
        "menu_15": "Өшіру (Жинақты/Тексерік)",
        "menu_16": "Жарияланудағы программалар",
        "menu_17": "Топтастыру",
        "menu_19": "Программалар тізімі",
        "menu_20": "Мәтінді өзгерту",
        "menu_21": "Программаны көшіру",
        "menu_23": "Программаны жариялау",
        "menu_24": "Материалдарды басқару",
        "menu_25": "Жүктеу",
        "menu_28": "Тез жариялау",
        "menu_29": "Шаблондарды басқару",
        "menu_30": "Жалпы шаблондар",
        "menu_31": "Енді қолданыңыз",
        "menu_32": "Менің шаблондарым",
        "menu_33": "Жалпы шаблондарға жариялау",
        "menu_35": "Бөлісу тарихы",
        "menu_36": "Тексеру басқару",
        "menu_37": "Программаларды тексеру",
        "menu_38": "Тексеру (Қабылдау/Қабылдамау)",
        "menu_39": "Материалдарды тексеру",
        "menu_41": "Тексеру тарихы (Оператор)",
        "menu_42": "Тексеру тарихы (Тексеруші)",
        "menu_43": "Қабылдау санына қарау",
        "menu_44": "Организацияны басқару",
        "menu_45": "Журналдарды басқару",
        "menu_46": "Орындату журналдары",
        "menu_47": "Жариялау журналдары",
        "menu_48": "Қате журналдары",
        "menu_49": "Өңдеу журналдары",
        "menu_50": "Файл журналдары",
        "menu_51": "Кіру журналдары",
        "menu_52": "Мәтінді қабылдау",
        "menu_53": "Сақтау жері",
        "menu_54": "Организация құрылымы",
        "menu_55": "Рөлдердің құқықтары",
        "menu_56": "Авторизация",
        "menu_57": "Қарау (Авторизация құқықтары)",
        "menu_58": "Организация әзелдері",
        "menu_60": "Төмендегі пайдаланушылдардың құпиясөзін қайта баптау",
        "menu_61": "Активтерді басқару",
        "menu_62": "Менің қалдықым",
        "menu_63": "Қарау (Қасса деталдары)",
        "menu_64": "Менің интернет трафикким",
        "menu_65": "Қарау (Трафик деталдары)",
        "menu_66": "Трафикті сатыну",
        "menu_67": "Менің көлемім",
        "menu_68": "Менің құрылғыларым",
        "menu_69": "Сатып алу деталдары",
        "menu_70": "Қарау (Толтыру)",
        "menu_71": "Қарау (Сатып алынған шаблондар)",
        "menu_72": "Қарау (Сатып алынған трафик)",
        "menu_73": "Басқа құқықтары",
        "menu_74": "Қарау (Материалдар мен программалар статистикасы)",
        "menu_75": "Қарау (Активтер)",
        "menu_76": "Қарау (Бұлақ трафик/статистика)",
        "menu_77": "Қарау (Онлайн құрылғылар статистикасы)"
    },
    login: {
        terminalServiceSystem: "Жедел терминалдар қызмет жүйесі",
        accountLogin: "Тіркеуден кіру",
        register: "Тіркелу",
        accountLoginTip: "Барлығы тіркеу арқылы кір",
        scanQRCode: "QR кодды сканерлеңіз",
        readAndAgree: "Мен оқып алдым және келісімшідемін",
        readAndAgreeLink: "Пайдаланушылар қызмет келісімі",
        readAndAgreeAgreement: "Пайдаланушылар қызмет келісімін оқып ал және келісімші болыңыз",
        forgetpassword: "Құпия сөзді ұмыттыңыз ба?",
        resetpassword: "Құпия сөзді қалпына келтіру",
        phoneEmptyTip: "Телефон нөмірін енгізіңіз",
        nextStep: "Келесі қадам",
        title: "Кіруге қош келдіңіз",
        submit: "Кіру",
        userName: "Тіркеу",
        password: "Құпия сөз",
        userNameEmptyTip: "Тіркеуді енгізіңіз",
        passwordEmptyTip: "Құпия сөзді енгізіңіз",
        passwordFormatTip: "Дұрыс құпия сөз формасын енгізіңіз",
        passwordIsOk: "Тексеру үшін құпия сөзді енгізіңіз",
        passwordSign: "Құпия сөзді енгізіңіз",
        codeTip: "Тексеру кодын енгізіңіз",
        phone: "Телефон нөмірі бос болмауы керек",
        code: "Тексеру коды бос болмауы керек",
        nickname: "Компания атауы бос болмауы керек",
        pass: "Құпия сөз бос болмауы керек",
        pwdMessage: "Құпия сөз ұзындығы 8~20 таңба, бос орынды қамтымауы және böyük және кішкентай әріптер, санлар, ерекше таңбалардың ішіндегі 3-ін қамтуы керек",
        pwdMessage01: "Құпия сөзге әріптер мен санларды енгізіңіз, онда аздап 8 таңба болсын",
        pwdMessage02: "Құпия сөз ұзындығы 8-20 таңба",
        pwdMessage03: "Құпия сөз бос орынды қамтымауы керек",
        pwdMessage04: "Құпия сөз böyük әріптер, кішкентай әріптер, санлар, белгілердің ішіндегі үш нәрсені қамтуы керек",
        newpassempty: "Жаңа құпия сөз бос болмауы керек",
        newpass: "Екі рет енгізілген құпия сөздер бірдей емес",
        getcode: "Тексеру кодын алу",
        format: "Телефон нөмірі формасы дұрыс емес",
        chongfa: "секундтан кейін қайта жіберу",
        isSend: "Жіберілді",
        noregister: "Тіркеу жоқпа? Дереу тіркеліңіз",
        Mobile: "Телефон нөмірі",
        verificationcode: "Тексеру коды",
        petname: "Нікнейм",
        Quickregistration: "Тез тіркелу",
        xiugaimima: "Құпия сөзді өзгерту",
        jiumima: "Ескі құпия сөз",
        xinmima: "Жаңа құпия сөз",
        zaicishuruxinmima: "Жаңа құпия сөзді қайта енгізіңіз",
        xiugaichenggong: "Өзгерту сәтті аяқталды",
        xiugaishoujihao: "Телефон нөмірін өзгерту",
        dengluzhanghao: "Кіру тіркеуі",
        gongsiid: "Компания ID",
        yonghunicheng: "Пайдаланушы нікнеймі",
        chuangjianshijian: "Құру уақыты",
        gongsimingcheng: "Компания атауы",
        denglumima: "Кіру құпия сөзі",
        jianyi: "Құпия сөзге әріптер мен санлардың қосындысын қолдануға ұсынылады",
        shezhimima: "Құпия сөзді орнату",
        shezhishoujihao: "Телефон нөмірін өзгерту/орнату",
        yibangding: "Байланыстырылған",
        weibangding: "Байланыстырылмаған",
        zhanghuanquan: "Тіркеу қауіпсіздігі",
        yonghuxinxi: "Пайдаланушы мәліметтері",
        zhuceSucMsg: "Табылды, тіркелу сәтті аяқталды!",
        verificationcodeSucMsg: "Тексеру коды сәтті жіберілді！",
        requiredIsEmpty: "Толтыруы шартты өрістер бос болмауы керек！",
        emailObj: {
            title: "Электрондық пошта",
            tit: "Электрондық поштамен кіру",
            tip: "Электрондық пошта адресіні енгізіңіз",
            formatTip: "Дұрыс электрондық пошта формасын енгізіңіз",
        },
        phoneObj: {
            title: "Телефон нөмірі",
            tit: "Телефонмен кіру",
            tip: "Телефон нөмірін енгізіңіз",
            formatTip: "Дұрыс телефон нөмірі формасын енгізіңіз",
        },
        emailOrPhoneObj: {
            title: "Электрондық пошта немесе телефон нөмірі",
            tit: "Электрондық пошта немесе телефон нөмірімен кіру",
            tip: "Электрондық пошта немесе телефон нөмірін енгізіңіз",
            formatTip: "Дұрыс электрондық пошта немесе телефон нөмірі формасын енгізіңіз",
        },
        wechatObj: {
            title: "Вечат",
            tit: "Вечатпен кіру",
        },
        googleObj: {
            title: "Google",
            tit: "Googleмен кіру",
        },
        confirm: "Шығарылды",
        confirmSubmit: "Шығаруды растау",
        cancel: "Болдырмау",
        close: "Жабу",
        bindSucMsg: "Байланыстыру сәтті аяқталды",
        toContinueBindAccount: "Үшінші тарап тіркеуін байланыстыруды tamamдау үшін жалғастырыңыз",
        bindTip01: "Тіркеу жоқпа? Біріншісін тіркеңіз",
        bindTip02: "Тіркеу бар",
        bindTip03: "Қазіргі үшінші тарап тіркеу платформа тіркеуіне байланыстырылмаған, келесі рет тез кіру үшін барлығы тіркеуді байланыстырыңыз немесе жаңа тіркеуді тіркеп байланыстырыңыз.",
        bindTip04: "Барлығы тіркеуді байланыстыру",
        bindTip05: "Жаңа тіркеуді тіркеп байланыстыру",
        bindTip06: "Сіз үшінші тараптан рұқсат алдыңыз, кіру мәліметтерін толтырып байланыстыруды tamamдауға болады",
        bindSubmit: "Байланыстыруды жіберу",
        enterAccountTip: "Тіркеу атауын енгізіңіз",
        RegisterAndBind: "Тіркеліп байланыстыру",
        loginErr: "Пайдаланушы атауы немесе құпия сөз дұрыс емес！",
        usercenter: "Пайдаланушы орталығы",
        pleaseInputName: "Атауыны енгізіңіз",
        operationSuccess: "Жұмыс сәтті аяқталды！",
        edit: "Өзгерту",
        xiugai: "Өзгерту",
        userData: "Жеке мәліметтер",
        changePassword: "Құпия сөзді өзгерту",
        account: "Тіркеу",
        userName01: "Пайдаланушы атауы",
        phoneNumber: "Телефон нөмірі",
        role: "Рөл",
        createTime: "Құру уақыты",
        genghuang: "Алмастыру",
        bangding: "Байланыстыру",
        unbind: "Байланыстыруды босату",
        plesaseSelectBindingType: "Байланыстыру типін таңдаңыз",
        pleaseConfirmCont: "Мен осы мәліметті оқып алдым деп растаңыз",
        confirmReadCont: "Мен осы мәліметті оқып алдым",
        frequentTip: "Жұмыс тым жиі, кейіннен қайта дәліріңіз!",
        zhuxiaoBtn: "Тіркеуді жою",
        zhuxiaoTitle: "Тіркеуді жою",
        querenZhuxiao: "Жоюды растау",
        jiXu: "Жалғастыру",
        sendCodeBtn: "Тексеру кодын жіберу",
        passwordIsNotOldPassword: "Тексеру құпия сөзі мен жаңа құпия сөз енгізілген нәрсе бірдей емес",
        passwordIsOldPassword: "Өзгертілген құпия сөз ескі құпия сөзбен бірдей",
        passFormatError: "Дұрыс құпия сөз формасын енгізіңіз",
        oldPassWord: "Ескі құпия сөз",
        newPassWord: "Жаңа құпия сөз",
        inputPlaceholder: "Енгізіңіз",
        confirmPassword: "Құпия сөзді растау",
        zhuxiaoTip: `
            1、Тіркеуді жою барысын қайтаруға болмайтын операция, тіркеу бір рет жоюлғаннан кейін сіз осы тіркеуден немесе осы тіркеу арқылы тіркеліп кірген үшінші тарап тіркеулерден кіру және қолдануға болмайды, тіркеуге қатысты мәліметтер мен деректерді өз лапыңыз.
            2、Бұл тіркеуді тіркеуден бұрын, барлық активтерді тазартып, ешқандай келіспеушілік болмағанын растауҙар; бұл тіркеу бір рет жоюлғаннан кейін, сіз осы тіркеудегі барлық активтер мен құқықтардың бәріне мүлікті босатыңыз деп саналады, және оны қайтаруға немесе іздеуге болмайды.
            3、Осы жеңіл телефон нөмірі арқылы тіркелген тіркеулер жалпы 3 рет жоюлғаннан кейін, осы телефон нөмірімен жаңа тіркеуді тіркеуге болмайды, соның қатар басқа ешқандай тіркеуді байланыстыруға болмайды.
        `
    },
    home: {
        title: "Басты бет",
        quickOperation: "Тез жұмыс",
        addDevice: "Құрылғы қосу",
        publishProgram: "Бағдарламаны жариялау",
        publishMaterial: "Материалды жариялау",
        makeProgram: "Бағдарламаны жасау",
        uploadMaterial: "Материалды жүктеу",
        todayData: "Бүгінгі деректер (сағат сайын жаңартылады)",
        playNumChart: "Ойнату санын есептеу",
        deviceOnlineStatus: "Құрылғының онлайн күйі",
        onLineDevice: "Онлайн құрылғылар",
        unLineDevice: "Оффлайн құрылғылар",
        programPlayTime: "Бағдарлама ойнату муддетін есептеу",
        downloadSoft: "Программалық забезпестікті жүктеу",
        adminApp: "Мобильді клиент",
        playerApp: "Інформация жариялау ойнату терминалы",
        downloadAdminApp: "Клиентті жүктеу үшін басыңыз",
        downloadPlayerApp: "Ойнату терминалыын жүктеу үшін басыңыз",
        aboutUs: "Біз туралы",
        userManual: "Пайдаланушы нұсқаулығы",
        message: "Хабарлама жіберуіңіз келеді",
    },
    device: {
        inputPlaceholder: "Енгізіңіз",
        selectPlaceholder: "Таңдаңыз",
        osTypeStr: "Терминал жүйесі",
        onLineStatus: "Онлайн күйі",
        dpi: "Айырымдылық",
        companyDeptIdName: "Т tillhörілген ұйым",
        deviceGroupIdName: "Т tillhörілген топ",
        editOrMove: "Өзгерту/жер değiştirу",
        loanOriginationFee: "Кредит комиссиясы",
        strategyInfoLook: "Стратегия мәліметтерін қарау",
        programLook: "Бағдарламаны қарау",
        addEquipments: "Құрылғы қосу",
        luminanceSet: "Жарықтың басқару",
        terminal: "Терминал баптаулары",
        transferCompany: "Бөлімге көтеру",
        releasedProgram: "Бағдарламаны жариялау",
        screenshot: "Экран түсіру",
        changeGroup: "Топты өзгерту",
        defaultGroup: "Әдеттегі топ",
        operation: "Жұмыс",
        edit: "Өзгерту",
        saveEdit: "Өзгертулерді сақтау",
        add: "Қосу",
        save: "Сақтау",
        setting: "Баптаулар",
        program: "Бағдарлама",
        unbind: "Байланыстыруды босату",
        sleep: "Һаңдау",
        wakeup: "Ояту",
        restart: "Қайта іске қосу",
        shutdown: "Шығару",
        reportLog: "Журналды жіберу",
        clearPlayData: "Ойнату терминалы деректерін тазарту",
        offlineWarn: "Бұл құрылғы оффлайн, құрылғы онлайн болғаннан кейін қайта дәліріңіз！",
        confirmUnbind: "Байланыстыруды босатуды растау",
        confirmReset: "Тазартуды растау",
        confirmDelete: "Жоюды растау",
        delete: "Жою",
        cancelDelete: "Жоюды болдырмау",
        confirmResetSuccess: "Тазарту сәтті аяқталды",
        confirm: "Шығарылды",
        cancel: "Болдырмау",
        operationSuccess: "Жұмыс сәтті аяқталды",
        unbindSuccess: "Байланыстыруды босату сәтті аяқталды",
        pleaseSelectDevice: "Құрылғыны таңдаңыз",
        pleaseSelectOnlineDevice: "Онлайн құрылғыны таңдаңыз",
        confirmMixOperation: "Таңдалған құрылғыларда оффлайн құрылғылар бар, бұл баптама оффлайн құрылғыларда әсер етпейді, жалғастыруды растаңыз？",
        pleaseSelectDate: "Күні таңдаңыз",
        reportSuccess: "Жіберу сәтті аяқталды",
        deviceSetting: "Құрылғы баптаулары",
        default: "Әдеттегі",
        all: "Барлығы",
        deviceList: "Құрылғылар тізімі",
        addDevice: "Құрылғы қосу",
        department: "Бөлім ұйымы",
        deviceType: "Айырымдылық",
        osType: "Терминал жүйесі",
        onlineState: "Онлайн күйі",
        online: "Онлайн",
        offline: "Оффлайн",
        notActive: "Активдеілмеген",
        search: "Кілт сөзді енгізіңіз",
        batchOperation: "Пакетте жұмыс",
        allDevices: "Барлық құрылғылар",
        deviceAttribute: "Құрылғылық қасиеттер",
        selectReportDate: "Жіберу күнін тазарту",
        inputName: "Атауыны енгізіңіз",
        inputWidth: "Еніні енгізіңіз",
        inputHeight: "Биіктігін енгізіңіз",
        inputResolutionRatio: "0-ден үлкен бүтін санды енгізіңіз！",
        inputSort: "Жерлестіруді енгізіңіз",
        serialNum: "Серія нөмірі",
        name: "Атауы",
        width: "Ені",
        height: "Биіктігі",
        resolutionRatio: "Айырымдылық",
        inputResolutionRatioName: "Айырымдылық атауын енгізіңіз",
        sort: "Жерлестіру",
        personal: "Жеке",
        system: "Жүйе",
        type: "Түрі",
        systemDefaultSettingUneditable: "Жүйенің әдеттегі баптаулары өзгертіле алмайды!",
        systemDefaultSettingUnDeletable: "Жүйенің әдеттегі баптаулары жоюла алмайды!",
        newz: "Жаңа қосу",
        total: "Жалпы",
        totalNum: "табы",
        strategyName: "Стратегия атауы",
        associatedTerminalNum: "Тасма терминалдар саны",
        createTime: "Құру уақыты",
        pleaseSelectStrategy: "Стратегияны таңдаңыз！",
        onlySelectOneData: "Тек бір деректі таңдауға болады！",
        downloadStrategy: "Стратегияны жүктеу",
        inputStrategyName: "Стратегия атауын енгізіңіз",
        luminanceControl: "Жарықтың басқару",
        volumeStrategy: "Дыбыстың стратегиясы",
        saveSuccess: "Сақтау сәтті аяқталды",
        screenAngle: "Экранды бұру (°)",
        startTime: "Бастау уақыты",
        endTime: "Аяқтау уақыты",
        repeat: "Қайталау",
        monday: "Дүйсенбі",
        tuesday: "Сейсенбі",
        wednesday: "Сәрсенбі",
        thursday: "Бейсенбі",
        friday: "Жұма",
        saturday: "Сенбі",
        sunday: "Жексенбі",
        everyday: "Күн сайын",
        downloadSpeed: "Жүктеу жылдамдығы",
        inputDownloadSpeed: "Жүктеу жылдамдығын енгізіңіз",
        operator: "Жұмыс",
        pleaseSelectDeleteData: "Жоюға болатын деректі таңдаңыз！",
        confirmBatchDelete: "Пакетте жоюды растаңыз ма？",
        pleaseInputName: "Атауыны енгізіңіз",
        detailSetting: "Терең баптаулар",
        weekPlan: "Апта жоспары",
        specialDateSetting: "Ерекше күн баптаулары",
        weekdayInfo: "Апта күнleri шартты өріс！",
        volumeInfo: "Дыбыс шартты өріс！",
        timeError: "Уақыт таңдауы дұрыс емес！",
        editSuccess: "Өзгерту жұмысы сәтті аяқталды！",
        addSuccess: "Қосу жұмысы сәтті аяқталды！",
        addSpecialPlan: "Ерекше стратегия жоспарын қосу",
        downloadSpeedInfo: "Жүктеу жылдамдығы:(0 жүктеуді жабу anlamına geledi)",
        pleaseSelectStartTime: "Бастау уақытын таңдаңыз",
        pleaseSelectEndTime: "Аяқтау уақытын таңдаңыз",
        luminanceError: "Дұрыс жарық мәнін енгізіңіз！",
        defaultLuminance: "Әдеттегі жарық",
        luminance: "Жарық мөлшері",
        defaultLuminanceInfo: "Әдеттегі жарық(100 ең жарықты, 0 ең қараңғы anlamına geledi)",
        volume: "Дыбыс",
        saveLuminance: "Жарықты сақтау",
        changeSuccess: "Өзгерту сәтті аяқталды！",
        changeNetwork: "Желіні алмастыру",
        netName: "Желі атауы",
        nameempty: "Желі атауы бос болмауы керек",
        currentNetwork: "Қазіргі желі",
        ipAddress: "IP адресі",
        dailyMode: "Күн сайын режим",
        weeklyMode: "Апта сайын режим",
        turnOnTime: "Кіру уақыты",
        turnOffTime: "Шығару уақыты",
        startSleep: "Һаңдауға бастау",
        endSleep: "Һаңдаудан аяқтау",
        batchDelInfo: "Таңдалған өрістерді жоюды растаңыз ма？",
        timeCannotBeEmpty: "Уақыт бос болмауы керек!",
        startUp: "Кіру",
        shutDown: "Шығару",
        volumeSize: "Дыбыс мөлшері",
        defaultVolume: "Әдеттегі дыбыс(100 ең үлкен, 0 тыныш anlamına geledi)",
        chooseStartTime: "Бастау уақытын таңдаңыз",
        chooseEndTime: "Аяқтау уақытын таңдаңыз",
        saveVolume: "Дыбысты сақтау",
        screenRotationUnSaved: "Экран бұрылуы сақталмаған",
        volumeSettingUnSaved: "Дыбыс баптаулары сақталмаған",
        luminanceSettingUnSaved: "Жарық баптаулары сақталмаған",
        confirmClosePopup: "Бұл всплыстыру панелін жабуды растаңызма?",
        volumeSettingSuccess: "Дыбыс өзгерту сәтті аяқталды",
        luminanceSettingSuccess: "Жарық өзгерту сәтті аяқталды",
        advancedSettingUnSaved: "Жоғары баптаулары сақталмаған",
        settingTitle: "Терминал баптаулары",
        volumeSetting: "Дыбыс баптаулары",
        luminanceSetting: "Жарық баптаулары",
        downloadSetting: "Жүктеу баптаулары",
        sleepSetting: "Һаңдау баптаулары",
        onOffSetting: "Уақытылған кір/шығару",
        screenRotation: "Экранды бұру",
        namingError: "Атау жіберілу дұрыс емес, файл атауында бос орын болмауы керек！",
        deleteSuccess: "Жою сәтті аяқталды",
        deleteFolder: "Папканы жою",
        pleaseInputDeviceName: "Құрылғы атауын енгізіңіз",
        pleaseInputDeviceId: "Құрылғы IDсын енгізіңіз",
        discoverDevice: "Құрылғыны анықтау",
        deviceId: "Құрылғы IDсы",
        bound: "Байланыстырылған",
        bind: "Байланыстыру",
        noDevice: "Құрылғы жоқ",
        refresh: "Жаңарту",
        manualAdd: "Қолмен қосу",
        deviceGroup: "Құрылғы классификациясы",
        pleaseSelectGroup: "Топты таңдаңыз！",
        deviceName: "Құрылғы атауы",
        goAdd: "Қосуға өту",
        close: "Жабу",
        bindCountInsufficient: "Байланыстыруға болатын сан жеткіліксіз, құрылғы санын yüksерттіңізden кейін қосыңыз！",
        displayNumber: "Көрсетілетін нөмір",
        groupName: "Топ атауы",
        pleaseSelectGroupName: "Топ атауын толтырыңыз！",
        moveGroup: "Топты көтеру",
        longitude: "Долгота",
        latitude: "Широта",
        nationality: "Ел",
        province: "Облыс",
        city: "Қала",
        county: "Аудан",
        outNetIp: "Сыртқы желі IP",
        inNetIp: "Ішкі желі IP",
        companyName: "Компания атауы",
        Info: "Тереңдіктер",
        android: "Android",
        win: "Windows",
        osVersion: "Жүйе нұсқасы",
        softwareVersion: "Программалық забезпестіктің нұсқасы",
        diskSize: "Диск өлшемі",
        useSize: "Жалынған өлшем",
        macAddr: "MAC адресі",
        longitudeLatitudeInfo: "Долгота мен широта бірден бос немесе бос емес болуы керек!",
        terminalName: "Терминал атауы",
        terminalGroup: "Терминал топы",
        reportJournal: "Жіберу керек пе？",
        systemVersion: "Жүйе нұсқасы",
        storageSpace: "Сақтау жері",
        resolution: "Айырымдылық",
        runningMemory: "Жолдастыру жады",
        model: "Моделі",
        registerStatus: "Тіркеу күйі",
        password: "Құпия сөз",
        passwordInfo: "6-ден 18-ге дейінгі сөздерді немесе санды енгізіңіз!",
        group: "Топ",
        address: "Адрес",
        remark: "Ескертпе",
        renewalPeriod: "Тасымалдау циклі",
        money: "Тегі",
        latitudeInfo: "Дұрыс широта мәнін енгізіңіз!",
        totalPayment: "Жалпы ақша",
        longitudeInfo: "Дұрыс долгота мәнін енгізіңіз!",
        setMeal: "Пакет",
        number: "Саны",
        programName: "Бағдарлама атауы",
        playStatus: "Ойнату күйі",
        playType: "Ойнату тәсілі",
        play: "Ойнау",
        pause: "Тауып отыру",
        playTime: "Ойнату уақыты",
        programDeleted: "Бағдарлама жоюлған",
        playSuccess: "Бағдарлама ойнатуға жасалған",
        pauseSuccess: "Тауып отыру сәтті аяқталды",
        playCycle: "Циклікалық ойнату",
        playInsert: "Қосымша ойнату",
        withdrawSuccess: "Қайтару сәтті аяқталды",
        withdrawInfo: "Қайтаруға болатын бағдарламаны біріншіден таңдаңыз！",
        programBelong: "Т tillhörілген бағдарлама",
        checkAll: "Барлығын таңдау",
        batchDel: "Пакетте жою",
        delConfirm: "Таңдалған өрістерді жоюды растаңыз ма？",
        check: "Таңдалған",
        noProgram: "Бағдарлама жоқ",
        details: "Тереңдіктер",
        screenshotFail: "Экран түсіру басарасыз",
        policyName: "Стратегия атауы",
        terminalNum: "Тасма терминалдар саны",
        powerStrategy: "Жарық беретін стратегия",
        pleaseSelectDepartment: "Бөлімді таңдаңыз！",
        screenshotControl: "Экран түсіру басқару",
        未激活: "Активдеілмеген",
        已激活: "Активдеілген",
        未绑定: "Байланыстырылмаған",
        已绑定: "Байланыстырылған",
    },
    programManage: {
        programList: "Бағдарламалар тізімі",
        publishProgram: "Бағдарлама жариялау жоспары",
        week1: "Дүйсенбі",
        week2: "Сейсенбі",
        week3: "Сәрсенбі",
        week4: "Бейсенбі",
        week5: "Жұма",
        week6: "Сенбі",
        week7: "Жексенбі",
        monday: "Дүйсенбі",
        tuesday: "Сейсенбі",
        wednesday: "Сәрсенбі",
        thursday: "Бейсенбі",
        friday: "Жұма",
        saturday: "Сенбі",
        sunday: "Жексенбі",
        name: "Атауы",
        preview: "Алдын көру",
        playDeviceNum: "Ойнату құрылғылар саны",
        copyDeviceCode: "Көшіру үшін басыңыз",
        osType: "Жүйе түрі",
        playDate: "Ойнату күні",
        playWeek: "Ойнату аптасы",
        everyday: "Күн сайын",
        start: "Бастау",
        end: "Аяқтау",
        playOperateStatusStr: "Жариялау күйі",
        playDevice: "Ойнату құрылғысы",
        downloadView: "Жүктеп қарау",
        publisher: "Жариялаушы",
        publishTime: "Жариялау уақыты",
        operation: "Жұмыс",
        add: "Қосу",
        groupName: "Топ атауы",
        selectDevice: "Терминалды таңдаңыз",
        searchDevice: "Терминалды іздеу",
        pleaseFillGroupName: "Топ атауын толтырыңыз！",
        remarkInfo: "Ескертпе",
        compile: "Өзгерту",
        withdrawConfirm: "Бұл бағдарламаны қайта алуды растаңыз ма？",
        confirm: "Шығарылды",
        cancel: "Болдырмау",
        withdraw: "Қайтару",
        batchWithdraw: "Пакетте қайтару",
        batchPublish: "Пакетте жариялау",
        batchDelete: "Пакетте жою",
        batchOperation: "Пакетте жұмыс",
        notUse: "Қолданылмаған",
        notChecked: "Тексерілмеген",
        notPass: "Көтерілмеген",
        delete: "Жою",
        publishTextLeft: "Жарияланған",
        offTextLeft: "Тауып отырған",
        pleaseSelectProgramToMove: "Көтеруге болатын бағдарламаны таңдаңыз！",
        pause: "Тауып отыру",
        pauseConfirm: "Тауып отыруды растаңыз ма？",
        play: "Ойнау",
        downloadUdisk: "Флеш дискке жүктеу",
        deviceList: "Құрылғылар тізімі",
        groupSelection: "Топ таңдауы",
        operationSuccess: "Жұмыс сәтті аяқталды",
        deleteSuccess: "Жою сәтті аяқталды",
        selectDate: "Күні таңдаңыз",
        publishStatus: "Жариялау күйі",
        checkStatus: "Тексеру күйі",
        waitAuditing: "Тексеруге түскен",
        auditPass: "Тексеруден өткен",
        auditRefuse: "Тексеруден бас тартылған",
        all: "Барлығы",
        playStatus: "Ойнауда",
        playStatust: "Ойнату күйі",
        pauseStatus: "Тауып отырған",
        notStartStatus: "Басталмаған",
        resolutionratio: "Айырымдылық",
        totalNum: "табы",
        programName: "Бағдарлама атауы",
        playStartTime: "Ойнату бастау уақыты",
        playEndTime: "Ойнату аяқтау уақыты",
        createTime: "Құру уақыты",
        nationality: "Ел",
        province: "Облыс",
        city: "Қала",
        county: "Аудан",
        address: "Адрес",
        ip: "IP адресі",
        location: "Жері",
        log: "Журнал",
        pleaseFillProgramName: "Бағдарлама атауын толтырыңыз！",
        selectGroup: "Топты таңдаңыз",
        startTime: "Бастау уақыты",
        endTime: "Аяқтау уақыты",
        publishCycle: "Жариялау циклі",
        publishDeviceNum: "Жариялау құрылғылар саны",
        pleaseSelectRecord: "Жоспарды таңдаңыз",
        deviceName: "Терминал атауы",
        deviceId: "Терминал құрылғы IDсы",
        deviceGroupIdName: "Т tillhörілген топ",
        notClassified: "Классификацияланмаған",
        osTypeStr: "Терминал жүйесі",
        storageSpace: "Сақтау жері",
        onLineStatus: "Онлайн күйі",
        onLine: "Онлайн",
        offLine: "Оффлайн",
        sleep: "Һаңдау",
        unknown: "Беймәлім",
        registerStatus: "Тіркеу күйі",
        trialPeriod: "Сынау мүдде",
        notActive: "Активдеілмеген",
        active: "Активдеілген",
        parameterError: "Параметрлер дұрыс емес!",
        pleaseSelectProgram: "Бағдарлама таңдаңыз!",
        pleaseSelectProgramEdit: "Өзгертуге болатын бағдарлама таңдаңыз!",
        confirmWithdrawSelectedProgram: "Таңдалған бағдарламаны қайта алуды растаңыз ма？",
        withdrawSuccess: "Қайтару сәтті аяқталды",
        allPrograms: "Барлық бағдарламалар",
        defaultGroup: "Әдеттегі топ",
        cannotShareEmptyProgram: "Бос бағдарламаны бөліске болмайды！",
        onlyShareYourProgram: "Тек сіз жасаған бағдарламаны бөліске болады!",
        pleaseSelectProgramEditPublishTime: "Жариялау уақытын өзгерткен бағдарлама таңдаңыз!",
        pleaseSelectDevice: "Құрылғыны таңдаңыз!",
        programDetail: "Бағдарлама тереңдіктері",
        errorReason: "Қате себебі",
        availableStorageSpaceInsufficient: "Қолданылуға болатын сақтау жері жеткіліксіз",
        partialDeviceReleaseFailure: "Бағдарламалардың бөлігі жариялауда басарасыз",
        allDeviceReleaseSuccess: "Барлық құрылғыларда бағдарлама сәтті жарияланды",
        partialDeviceReleaseSuccess: "Бағдарламалардың бөлігі сәтті жарияланды",
        allGroup: "Барлық топтар",
        allProgram: "Барлық бағдарламалар",
        unGrouped: "Топталмаған",
        replaceProgram: "Бағдарлама алмастыру",
        replaceProgramTip: "Жаңа жарияланған бағдарлама ойнату терминалыында бұрын жіберілген бағдарлама деректерін алмастырады！",
        screen: "Бір/екі экран",
        singleScreen: "Бір экран",
        doubleScreen: "Екі экран",
        playSetting: "Ойнату баптаулары",
        batchPlaySetting: "Ойнату уақытын пакетте баптау",
        individualPlaySetting: "Ойнату уақытын бір-бірінше баптау",
        playTime: "Ойнату уақыты",
        daily: "Күн сайын",
        weekdays: "Дүйсенбіден Жұмаға дейін",
        monthly: "Бұл айда",
        advancedSetting: "Жоғары баптаулар",
        playProgram: "Бағдарламаны ойнау",
        searchProgram: "Кілт сөзді енгізіңіз",
        shareAddressNotExist: "Сілтеме адресі жоқ, қайта дәліріңіз",
        copySuccess: "Көшіру сәтті аяқталды",
        shareLink: "Бөлісу сілтемесі",
        publish: "Жариялау",
        noResource: "Ресурс жоқ",
        single: "Бір экран",
        double: "Екі экран",
        time: "Уақыт",
        associatedTerminalNum: "Тасма терминалдар саны",
        default: "Әдеттегі",
        moveGroup: "Топты көтеру",
        pleaseSelectGroup: "Топ атауын толтырыңыз！",
        copy: "Көшіру",
        FUBEN: "Нұсқасы",
        nameempty: "Атауы бос болмауы керек",
        whitespace: "Атау жіберілу дұрыс емес, файл атауында бос орын болмауы керек！",
        programWhitespace: "Атау жіберілу дұрыс емес, бағдарлама атауында бос орын болмауы керек！",
        pleaseSelectResolution: "Айырымдылықты таңдаңыз！",
        dataError: "Деректер дұрыс емес！",
        createProgram: "Жаңа бағдарлама жасау",
        directCreate: "Кепілді жасау",
        myTemplate: "Менің шаблоным",
        use: "Қолдану",
        free: "Тегіс",
        loadMore: "Толығырақ жүктеу",
        confirmDelete: "Жоюды растау",
        deleteGroup: "Топты жою",
        notPublished: "Жарияланмаған",
        notPassed: "Көтерілмеген",
        notUsed: "Қолданылмаған",
        confirmDeleteSelectedProgram: "Таңдалған бағдарламаны жоюды растаңыз ма？",
        companyName: "Компания атауы",
        programCannotDownload: "Бұл бағдарламаны жүктеуге болмайды！",
        publishMaterial: "Материалды жариялау",
        playMaterial: "Материалды ойнау",
        pleaseInputMaterialName: "Материал атауын енгізіңіз",
        size: "Өлшемі",
        pleaseInputDeviceName: "Құрылғы атауын енгізіңіз",
        item: "табы",
        allMaterial: "Барлық материалдар",
        allDevices: "Барлық құрылғылар",
        "saveSuccess": "Сақталды",
        "savefaill": "Сақтау başarısız болды",
        "playMode": "Ойнату режимі",
        "cyclePlay": "Циклікалық ойнату",
        "insertPlay": "Кіртілген ойнату",
        "noData": "Мағлұмат жоқ",
        "Add": "Қосыңыз",
        "replace": "Алмастыру",
        "repeat": "Қайталау",
        "start01": "Бастау",
        "end01": "Аяқтау",
        "startDate": "Бастау күні",
        "endDate": "Аяқтау күні",
        "useNow": "Деген сәтте қолдану",
        "fillStartEndTimeFirst": "Қосу алдында бастау мен аяқтау уақытын толтырыңыз",
        "fillFullPlayTime": "Толық ойнату уақытын толтырыңыз",
        "fillCorrectPlayTime": "Дұрыс ойнату мерзімін толтырыңыз",
        "sDateAndEDateBothEmptyOrFilled": "Бастау күні мен аяқтау күні екісі бос немесе екісі толтырылған болуы керек"
    },
    source: {
        addResource: "Ресурсты қосу",
        width: "Ені",
        height: "Биіктігі",
        size: "Өлшемі(KB)",
        name: "Атауы",
        pleaseInputResourceName: "Ресурс атауын енгізіңіз！",
        addToGroup: "Топқа қосу",
        remark: "Ескертпе",
        promptFgIllustrate: "Иллюстрация",
        promptFgRealisticPhoto: "Реалистік фотосурет",
        promptFgSimplisticDrawing: "Қысқа шартта салу",
        promptFgChineseStyle: "Қытай стиль",
        promptFgPixelArt: "Пиксель стиль",
        noModel: "Модель жоқ, менеджермен байланысыңыз！",
        getModelFailed: "Модельді алу басарасыз, кейіннен қайта дәліріңіз！немесе менеджермен байланысыңыз！",
        createImagePrompt: "Сурет жасалуда, кейіннен жабыңыз！",
        promptEmpty: "Суреттің сатырмасын енгізіңіз",
        dpiEmpty: "Суреттің қатынасын таңдаңыз！",
        fgEmpty: "Стильді таңдаңыз！",
        style: "Стиль",
        idEmpty: "Сурет IDсы бос болмауы керек",
        exist: "Бұл сурет материалдарда бар",
        addSuccess: "Материал сәтті қосылды",
        saveError: "Суретті сақтау басарасыз, кейіннен қайта дәліріңіз！",
        delSuccess: "Жою сәтті аяқталды",
        generateImage: "Мәтіннен сурет жасау",
        generateImagePlaceholder: "Жасауыңыз келген суретті енгізіңіз, мысалы: Бір қашық күнделік тамақтарда жарықтандырып жүреді",
        aiExpand: "Жидди ақпаратты кеңейту",
        negativePrompt: "Төменгі сатырма",
        negativePromptTooltip: "Шығарылымда пайдаланушының болmasını қалмаған контентті немесе сипаттарды анық айқындау үшін қолданылады",
        imageRatio: "Суреттің қатынасы",
        generateImageBtn: "Дереу жасау",
        shengchengjieguo: "Жасалу нәтижесі",
        generateImageLoadingTip: "Жасалуда, қайта басыңыз немесе жабмаңыз...",
        Tooltip: "Жидди ақпаратпен сіздің жасағаншылығыңызды жасап көріңіз",
        saveToMaterial: "Материалдарға сақтау",
        publish: "Дереу жариялау",
        download: "Жүктеу",
        generateHistory: "Жасалу тарихы",
        hide: "Жабу",
        cancel: "Болдырмау",
        useExpand: "Кеңейтуді қолдану",
        all: "Барлығы",
        delete: "Жою",
        loadMore: "Толығырақ жүктеу",
        aiTip: "Мәтін жасанды интеллект моделімен жасалған, платформаның көзқарасын, тұлғасын немесе көзқарасын білдірмейді, Жидди ақпарат контентін дұрыс және қанықтандырулы қолданыңыз",
        operationSuccess: "Жұмыс сәтті аяқталды",
        moveGroup: "Топты көтеру",
        groupName: "Топ атауы",
        pleaseSelectGroup: "Топ атауын таңдаңыз！",
        shenhe: "Тексеру",
        shenheStatus: "Тексеру күйі",
        shenheSuccess: "Тексеруден өткен",
        shenheRefuse: "Тексеруден бас тартылған",
        pleaseSelectShenheStatus: "Тексеру күйін таңдаңыз！",
        shenheRemark: "Тексеру ескертпе",
        pleaseInputShenheRemark: "Тексеру ескертпесін енгізіңіз！",
        pleaseInputFileName: "Файл атауын енгізіңіз！",
        whitespace: "Атау жіберілу дұрыс емес, файл атауында бос орын болмауы керек！",
        dataError: "Деректер дұрыс емес！",
        confirmDelete: "Жоюды растау",
        confirm: "Шығарылды",
        deleteFolder: "Папканы жою",
        add: "Қосу",
        edit: "Өзгерту",
        fileName: "Файл атауы",
        group: "Топ",
        resolution: "Айырымдылық",
        type: "Түрі",
        image: "Сурет",
        music: "Музыка",
        video: "Бейне",
        uploadTime: "Жүктеу уақыты",
        uploadUser: "Жүктеуші",
        checkTime: "Тексеру уақыты",
        checkUser: "Тексеруші",
    },
    setting: {
        nameempty: "Атауы бос болмауы керек",
        heightempty: "Биіктігі бос болмауы керек",
        widthempty: "Ені бос болмауы керек",
        resolutionratio: "Айырымдылық",
        name: "Атауы",
        opteration: "Жұмыс",
        compile: "Өзгерту",
        delete: "Жою",
        newz: "Жаңа қосу",
        compileratio: "Айырымдылықты өзгерту",
        sheizhifenbianlvmingcheng: "Айырымдылық атауын орнату",
        shezhigaodu: "Биіктігіні орнату",
        shezhikuandu: "Еніні орнату",
        xinzengfenbianlv: "Жаңа айырымдылық қосу",
        bianma: "Кодтау",
        bianjizhongduanmingcheng: "Терминал атауын өзгерту",
        xinzengzhongduan: "Жаңа терминал қосу",
        selectPrimaryColor: "Тақырып түсін таңдаңыз",
        fullScreen: "Толық экран",
        exitFullScreen: "Толық экраннан шығу",
    },
    tabs: {
        refresh: "Жаңарту",
        refreshAll: "Барлығын жаңарту",
        close: "Жабу",
        closeOthers: "Басқаларды жабу",
        closeAll: "Барлығын жабу",
        closeLeft: "Сол жақты жабу",
        closeRight: "Оң жақты жабу",
    },
    errorPage: {
        needLogin: "Сіз әлі кірген жоқсыз！",
        pageNotFound: "Сіз кірген бет жоқ！",
        redirectTo: "Басқа бетіне аудару",
        orReturn: "немесе қайтару",
        previousStep: "Алдыңғы қадам",
    },
    headerUs: {
        systemNotice: "Жүйе хабарламасы",
        allNotices: "Барлық хабарламалар",
        viewAllMessages: "Барлық хабарламаларды қарау",
        contactUs: "Бізбен байланысыңыз",
        operationSuccess: "Жұмыс сәтті аяқталды！",
        leaveMessage: "Хабарлама жіберуіңіз келеді",
        messageTitle: "Тақырып",
        messageTitleTip: "Тақырыпты енгізіңіз！",
        messageContentTip: "150 таңбадан аспау",
        submit: "Жіберу",
        markAsRead: "Оқылған деп белгілеу",
        success: "Жұмыс сәтті аяқталды！"
    },
    material: {
        allMaterial: "Барлық материалдар",
        defaultGroup: "Әдеттегі топ",
        auditStatus: "Тексеру күйі",
        auditPassed: "Тексеруден өткен",
        auditRejected: "Тексеруден бас тартылған",
        pendingAudit: "Тексеруге түскен",
        all: "Барлығы",
        operateSuccess: "Жұмыс сәтті аяқталды！",
        pleaseSelectMaterial: "Материалды таңдаңыз！",
        moveGroup: "Топты көтеру",
        pleaseSelectGroup: "Топты таңдаңыз！",
        batchPublish: "Пакетте жариялау",
        batchRecall: "Пакетте қайтару",
        batchDelete: "Пакетте жою",
        materialList: "Материалдар тізімі",
        uploadMaterial: "Материалды жүктеу",
        materialType: "Материал түрі",
        pleaseInputMaterialName: "Материал атауын енгізіңіз",
        selectAll: "Барлығын таңдау",
        confirmDeleteSelectedMaterial: "Таңдалған материалдарды жоюды растаңыз ма？",
        deleteSuccess: "Жою сәтті аяқталды",
        delete: "Жою",
        publish: "Жариялау",
        recall: "Қайтару",
        confirmRecallSelectedMaterial: "Таңдалған материалдарды қайта алуды растаңыз ма？",
        pleaseSelectMaterialGroup: "Материал топты таңдаңыз！",
        recallSuccess: "Қайтару сәтті аяқталды",
        publishSuccess: "Жариялау сәтті аяқталды",
        batchOperate: "Пакетте жұмыс",
        item: "табы",
        confirmDelete: "Жоюды растаңыз ма？",
        edit: "Өзгерту",
        confirmRecall: "Қайтаруды растаңыз ма？",
        unaudited: "Тексерілмеген",
        notPassed: "Көтерілмеген",
        operate: "Жұмыс",
        resolution: "Айырымдылық",
        none: "Жоқ",
        confirm: "Шығарылды",
        cancel: "Болдырмау",
        AICreation: "Жидди ақпаратпен жасау",
    },
    uploadFile: {
        operationSuccess: "Жұмыс сәтті аяқталды",
        uploadFile: "Жүктеуді басқару",
        uploadSuccess: "Жүктеу сәтті аяқталды",
        uploadCompleted: "Жүктеу tamamланды",
        uploadFail: "Жүктеу басарасыз",
        ConversionFailed: "Алмастыру басарасыз！",
        loading: "Жүктеуде...",
        beQueuing: "Қатарда...",
        Uploading: "Жүктеуде...",
        ConversionIng: "Алмастыруда...",
        ConventionalResources: "Әдеттегі ресурстар",
        DocumentResources: "Документ ресурстары",
        complete: "Тамам",
        upload: "Жүктеу",
        fileSizeWraning01: "Материал өлшемі aşқан",
        fileSizeWraning02: "Өзгертіп қайта жүктеңіз！",
        fileIsEmpty: "Файл бос",
        uploadFileTip: "Қолданылатын файл форматы жоқ",
        unablePreview: "Материал қорына сәтті қосылмаған, алдын көруге болмайды",
        confirmDelete: "Жоюды растаңыз ма？",
        deleteSuccess: "Жою сәтті аяқталды",
        delete: "Жою",
        confirm: "Шығарылды",
        preview: "Алдын көру",
        close: "Жабу",
        cancel: "Болдырмау",
        fileType: "Файл түрі",
        fileSize: "Файл өлшемі",
        conversionProgress: "Алмастыру прогресі",
        progress: "Прогрес",
        image: "Сурет",
        video: "Бейне",
        audio: "Музыка",
        limitTip01: "Бір ретте жүктеу",
        limitTip02: "файл",
        okTip: "Материал жүктеуде, кейіннен жабыңыз！",
        usableSize: "Қолданылуға болатын көлем",
        sizeUnableTip: "Қазіргі қолданылуға болатын сақтау жері жеткіліксіз, жарамсыз материалдарды уақытша тазартып орын тастаңыз немесе дилермен байланысып көлемді кеңейтіңіз.",
        view: "Тереңдіктерді қарау",
        fileName: "Файл атауы",
    },
    template: {
        inputPlaceholder: "Енгізіңіз",
        selectPlaceholder: "Таңдаңыз",
        noAuths: "Рұқсат жоқ, менеджермен байланысыңыз",
        operationSuccess: "Жұмыс сәтті аяқталды",
        total: "Жалпы",
        totalNum: "табы",
        dan: "Бір",
        shaung: "Екі",
        pleaseSelectGroup: "Топты таңдаңыз",
        preview: "Алдын көру",
        free: "Тегіс",
        use: "Қолдану",
        dpi: "Айырымдылық",
        delete: "Жою",
        confirmDelete: "Жоюды растау",
        confirmDeleteSelectedTemplate: "Бұл шаблонды жоюды растаңыз ма",
        push: "Жариялау",
        pushConfirm: "Жалпы шаблонға жариялауды растаңыз ма",
        pushRemovalConfirm: "Жалпы шаблоннан шығарылуды растаңыз ма",
        templateOrderRecord: "Шаблон тапсырыс жоспары",
        unpublished: "Жарияланмаған",
        auditing: "Тексеруде",
        publishRejected: "Жариялау бас тартылған",
        publishSuccess: "Жариялау сәтті аяқталды",
        offShelf: "Шығарылу",
        公共模版: "Жалпы шаблон",
        我的模板: "Менің шаблоным",
        共享记录: "Бөлісу жоспары",
        name: "Атауы",
        pubdate: "Жариялау уақыты",
        keySeachTip: "Кілт сөзді енгізіңіз",
        allGroup: "Барлық топтар",
        add: "Қосу",
        edit: "Өзгерту",
        programName: "Бағдарлама атауы",
        selectGroup: "Топты таңдаңыз",
    },
    checkManage: {
        total: "Жалпы",
        totalNum: "табы",
        operationSuccess: "Жұмыс сәтті аяқталды",
        checkUserLogs: "Тексеру жоспары (Оператор)",
        checkLogs: "Тексеру жоспары (Тексеруші)",
        sourceCheck: "Материал тексеру",
        programCheck: "Бағдарлама тексеру",
        checkAll: "Барлығын таңдау",
        auditPass: "Тексеруден өткен",
        auditRefuse: "Тексеруден бас тартылған",
        auditPass01: "Өткен",
        auditRefuse01: "Бас тартылған",
        auditRefuse02: "Тексеруден бас тарту",
        auditor: "Тексеруші",
        agentUserName: "Жариялаушы",
        interrogationTime: "Тексеруге тапсыру уақыты",
        checkTime: "Тексеру уақыты",
        checkName: "Тексеру атауы",
        checkType: "Тексеру түрі",
        checkIp: "Тексеруге тапсыру IP адресі",
        checkReason: "Хабарлама",
        checkStatus: "Жұмыс контенті",
        rangePicker: "Тексеру күні",
        keyWord: "Кілт сөз",
        all: "Барлығы",
        program: "Бағдарлама",
        material: "Материал",
        dan: "Бір",
        shaung: "Екі",
        pleaseSelectProgram: "Бағдарлама таңдаңыз!",
        pleaseSelectMaterial: "Материалды таңдаңыз！",
        preview: "Алдын көру",
        dpi: "Айырымдылық",
        auditRefuseTip: "Бас тарту себебін енгізіңіз",
        unreviewed: "Тексерілмеген",
        notPassed: "Көтерілмеген",
        notUsed: "Қолданылмаған",
        edit: "Өзгерту",
        none: "Жоқ",
        name: "Атауы",
        size: "Өлшемі",
        type: "Түрі",
        uploadTime: "Жүктеу уақыты",
        uploadUser: "Жүктеуші",
        checkUser: "Тексеруші",
        image: "Сурет",
        music: "Музыка",
        video: "Бейне",
    },
    systemSet: {
        total: "Жалпы",
        totalNum: "табы",
        inputPlaceholder: "Енгізіңіз",
        selectPlaceholder: "Таңдаңыз",
        userList: "Организация мүшелері",
        roleList: "Рөл рұқсаттары",
        department: "Организация құрылымы",
        diskInfo: "Сақтау жері",
        approveSet: "Мәтінді растау",
        logList: "Журналды басқару",
        name: "Атауы",
        account: "Тіркеу",
        userName: "Пайдаланушы атауы",
        phoneNumber: "Телефон нөмірі",
        role: "Рөл",
        createTime: "Құру уақыты",
        operation: "Жұмыс",
        edit: "Өзгерту",
        delete: "Жою",
        addNew: "Жаңа қосу",
        add: "Қосу",
        resetPassword: "Құпия сөзді қалпына келтіру",
        confirmDelete: "Жоюды растау",
        departmentOrganization: "Бөлім ұйымы",
        addNewUser: "Жаңа пайдаланушы қосу",
        pleaseEnterUserName: "Пайдаланушы атауын енгізіңіз",
        confirmPasswordNotMatch: "Тексеру құпия сөзі мен құпия сөз бірдей емес!",
        operationSuccess: "Жұмыс сәтті аяқталды！",
        userNickname: "Пайдаланушы атауы",
        pleaseEnterUserNickname: "Пайдаланушы атауын енгізіңіз",
        userNicknameRequired: "Пайдаланушы атауы бос болмауы керек！",
        password: "Құпия сөз",
        pleaseEnterPassword: "Құпия сөзді енгізіңіз",
        passwordRequired: "Құпия сөз бос болмауы керек！",
        passwordTip: "Сіздің құпия сөзіңіздің қауіпсіздігі төмен (құпия сөзде böyük және кішкентай әріптер, санлар, ерекше таңбалардың кез келген 3-і болуы керек және ұзындығы 8-ден)",
        confirmPassword: "Құпия сөзді растау",
        pleaseEnterPhoneNumber: "Телефон нөмірін енгізіңіз",
        phoneNumberRequired: "Телефон нөмірі бос болмауы керек！",
        phoneNumberFormatError: "Дұрыс телефон нөмірі формасын енгізіңіз！",
        roleRequired: "Рөл бос болмауы керек！",
        required: "Бос болмауы керек！",
        departmentName: "Бөлім",
        modifyPassword: "Құпия сөзді өзгерту",
        newPassword: "Жаңа құпия сөз",
        pleaseEnterNewPassword: "Жаңа құпия сөзді енгізіңіз",
        pwdMessage: "Құпия сөз ұзындығы 8~20 таңба, бос орынды қамтымауы және böyük және кішкентай әріптер, санлар, ерекше таңбалардың ішіндегі 3-ін қамтуы керек",
        all: "Барлығы",
        noAuths: "Рұқсат жоқ, менеджермен байланысыңыз",
        departmentName01: "Бөлім атауы",
        image: "Сурет",
        music: "Музыка",
        video: "Бейне",
        buySize: "Сатып алу саны",
        totalMoney: "Төлем ақшасы",
        buycreateTime: "Сатып алу уақыты",
        endTime: "Аяқталу уақыты",
        buyTypeStr: "Тапсырыс түрі",
        sourceCheck: "Материал тексеру",
        programCheck: "Бағдарлама тексеру",
        programName: "Бағдарлама атауы",
        diskExpansion: "Жолдастыру процесінде біткен/қолданылмаған материалдарды уақытша тазартып жүйенің қолданылуға болатын көлемін қамтамасыз етуге ұсынылады. Егер сізге daha böyük орын керек болса, құрылғы поставщисымен байланысып бұлттық сақтау жері көлемін кеңейту қызметін алуға болады. Бұл қызметтің шығындары болуы мүмкін, нақты ақпаратты дилердің ақпаратына байланысты alın.",
        selectPermission: "Рұқсатты таңдаңыз",
        checkPermission: "Рұқсатты белгілеңіз",
        addRole: "Рөл қосу",
        enterRoleName: "Рөл атауын енгізіңіз",
        roleName: "Рөл атауы",
        roleNameRequired: "Рөл атауы бос болмауы керек！",
        remark: "Ескертпе",
        enterRemark: "Ескертпені енгізіңіз",
        permissionSetting: "Рұқсат баптаулары",
        deleteSuccess: "Жою сәтті аяқталды！",
        confirmToDelete: "Жоюды растаңыз ма？",
        orgName: "Ұйым атауы",
        orgNameRequired: "Ұйым атауы бос болмауы керек！",
        orgRemark: "Ұйым ескертпе",
        enterOrgRemark: "Ұйым ескертпесін енгізіңіз",
        capacityUsage: "Көлем қолдану күйі",
        usedCapacity: "Жалынған көлем",
        totalCapacity: "Жалпы көлем",
        remainingCapacity: "Қалған көлем",
        capacityExpansion: "Көлемді кеңейту",
        enable: "Ашу",
        disable: "Жабу",
        userName01: "Пайдаланушы атауы",
        loginTime: "Кіру уақыты",
        ipAddress: "IP адресі",
        loginResult: "Кіру нәтижесі",
        selectDate: "Күні таңдаңыз",
        enterDate: "Күні таңдаңыз",
        selectStartTime: "Бастау уақытын таңдаңыз",
        selectEndTime: "Аяқтау уақытын таңдаңыз",
        enterUserName: "Пайдаланушы атауын енгізіңіз",
        userCount: "Пайдаланушылар саны",
        roleDesc: "Рөл сипаттамасы",
        roleAuthorization: "Рөл рұқсаты",
        success: "Сәтті",
        failure: "Басарасыз",
        time: "Уақыт",
        operationContent: "Жұмыс контенті",
        playCount: "Ойнату саны",
        playDuration: "Ойнату муддесі",
        selectDevice: "Құрылғыны таңдаңыз",
        enterProgramName: "Бағдарлама атауын енгізіңіз",
        serialNumber: "Серія нөмірі",
        publishContentName: "Жариялау контент атауы",
        playMode: "Ойнату тәсілі",
        cyclePlay: "Циклік ойнату",
        insertPlay: "Қосымша ойнату",
        paddingPlay: "Толтырма ойнату",
        playDeviceId: "Ойнату құрылғы IDсы",
        playDeviceName: "Ойнату құрылғы атауы",
        publishTime: "Жариялау уақыты",
        downloadStatus: "Жүктеу күйі",
        notDownloaded: "Жүктелмеген",
        downloading: "Жүктеуде",
        downloadSucceeded: "Жүктеу сәтті аяқталды",
        downloadFailed: "Жүктеу басарасыз",
        enterPublishContentName: "Жариялау контент атауын енгізіңіз",
        terminalId: "Терминал IDсы",
        belongOrg: "Т tillhörілген ұйым",
        reportTime: "Жіберу уақыты",
        reportIp: "Жіберу IP адресі",
        logInfo: "Журнал ақпараты",
        details: "Тереңдіктер",
        confirmDeletion: "Жоюды растаңыз ма？",
        logDetails: "Журнал тереңдіктері",
        download: "Жүктеу",
        deptOrg: "Бөлім ұйымы",
        query: "Запрос",
        queryByTerminalId: "Терминал IDсы бойынша запрос",
        batchDeleteLogs: "Журналдарды пакетте жою",
        customTimeDeleteLogs: "Қолданушы уақыты бойынша журналдарды жою",
        selectTimeRangeFirst: "Алдымен уақыт диапазонын таңдаңыз",
        deleteAllDeviceLogsIfEmpty: "Егер құрылғы IDсын толтырмаңыз болса, әдеттегі барлық құрылғылардың журналдарын жою",
        enterDeviceIdToDeleteLogs: "Журналды жоюға болатын құрылғы IDсын енгізіңіз",
        confirmDeleteAction: "Жоюды растау",
        selectDeleteRangeFirst: "Алдымен жою диапазонын таңдаңыз",
        networkConnectionFailed: "Желі байланысы жоғары",
        playLog: "Ойнату журналы",
        publishLog: "Жариялау журналы",
        errorLog: "Қате журналы",
        operationLog: "Жұмыс журналы",
        fileLog: "Файл журналы",
        userOperateLog: "Кіру журналы"
    },
    userManual: {
        userManual: "Пайдаланушы нұсқаулығы",
        noData: "Деректер жоқ"
    },
    systemNotice: {
        systemNotice: "Жүйе хабарламасы",
        noData: "Деректер жоқ",
        total: "Жалпы",
        totalNum: "табы",
        "markAllRead": "Барлығын оқылған деп белгілеу",
        "deleteAll": "Барлығын жою",
        "all": "Барлығы",
        "unread": "Оқылмаған",
        "read": "Оқылған",
        "type": "Түрі",
        "content": "Мәтін",
        "date": "Күн",
        "status": "Күйі",
        "confirmDelete": "Жоюды растаңыз ма？",
        "confirm": "Рақет",
        "cancel": "Болдырмау",
        "delete": "Жою"
    }
};